import { IconButton, TextField, TextFieldProps } from "@mui/material";
import * as React from "react";
import { ChangeEvent, useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

type Props = {
  placeholder: string;
  handleSearch: (searchValue: string) => void;
  reset: boolean;
};

export const RhfControlledDataTableFilter = ({
  placeholder,
  handleSearch,
  reset,
  ...otherProps
}: Props & TextFieldProps) => {
  const [search, setSearch] = useState<string>("");

  useEffect(() => {
    setSearch("");
  }, [reset]);

  return (
    <TextField
      {...otherProps}
      value={search}
      size="small"
      placeholder={placeholder}
      onChange={(event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) =>
        setSearch(event.target.value?.toUpperCase())
      }
      onKeyUp={(event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === "Enter" && search?.length !== 0) handleSearch(search.toUpperCase());
      }}
      InputLabelProps={{
        shrink: true,
      }}
      InputProps={{
        endAdornment: (
          <IconButton
            disabled={search?.length === 0}
            edge="end"
            onClick={(_) => handleSearch(search.toUpperCase())}
          >
            <SearchIcon />
          </IconButton>
        ),
      }}
      sx={{ width: "200px", pt: "0.3rem" }}
    />
  );
};
